
// 1-15个字符
export const REG_USER_INPUT = /([^\s]){1,15}$/g;

//字母，数字的校验
export const REG_COUPON_INPUT = /^([a-zA-Z]|\d){1,30}$/;


// WEBPACK FOOTER //
// ./src/utils/regs.js